/*从树形数据中递归筛选目标数据*/
export const valInDeep = (arr = [], val, id, childs) => {
  return arr.reduce((flat, item) => {
    return flat.concat(
      item[id] === val ? item : valInDeep(item[childs] || [], val, id, childs)
    )
  })
}

/*将树形数据向下递归为一维数据*/
export const flattenDeep = (arr = [], childs) => {
  return arr.reduce((flat, item) => {
    return flat.concat(
      item,
      item[childs] ? flattenDeep(item[childs], childs) : []
    )
  },[])
}

/*将树形数据向上将此支线递归为一维数组*/
export const flattenDeepParents = (arr, parent) => {
  return arr.reduce((flat, item) => {
    return flat.concat(
      item[parent] || [],
      item[parent] ? flattenDeepParents([item[parent]], parent) : []
    )
  },[])
}

/*根据条件递归祖先元素*/
export const regDeepParent = (row, parent, reg) => {
  if (row[parent]){
    reg && reg(row[parent])
    regDeepParent(row[parent], parent, reg)
  }
}

/*将数组转换成树结构*/
export const arrayToTree = (array=[],options={id:'id',pid:'pid',children:'children'}) => {
  let array_ = [] //创建存储剔除叶子节点后的骨架节点数组
  let unique = {} //创建盒子辅助本轮children合并去重
  array.forEach(item=>{
    let root = ['undefined',undefined,null].includes(item[options.pid])
    if (root) item[options.pid] = 0
    let children_array = array.filter(
      it=>it[options.pid] === item[options.id]
    )
    if (item.children && item.children instanceof Array) {
      item.children.map(i => (unique[i[options.id]]=1))
      item.children.push(
        ...children_array.filter(i => unique[i[options.id]] !== 1)
      )
    } else {
      item.children = children_array
    }
    let has_children = children_array.length > 0
    if (has_children && [0, '0'].includes(item[options.pid])) {
      array_.push(item)
    }
  })
  //当数组内仅有根节点时退出，否组继续处理 最终递归深度次
  if (!array_.every(item => [0, '0'].includes(item[options.pid]))) {
    return arrayToTree(array_,options)
  }else {
    return array_
  }
}



// WEBPACK FOOTER //
// ./src/components/userManagement/tree-transfer/array.js